import { handleApiResponse, notifyInternalMessage } from '@/functions';
import { useMutation } from '@tanstack/react-query';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TDataVariables = { userId: string };
type TResponseData = void;

export const useRequestDeleteCreator = () => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.referrals, 'delete'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .delete<TResponseData>(routes.api.referrals, data)
        .then(handleApiResponse)
        .catch(notifyInternalMessage),
    onSuccess: () => invalidate(routes.api.referrals)
  });

  const trigger = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoading: isPending,
    trigger,
    error
  });

};
